import { all, fork } from "redux-saga/effects";
import minMaxSaga from "../minMax-saga";

export default function* minMaxRootSaga() {
  yield all([fork(minMaxSaga)]);
}


